export default __webpack_public_path__ + "static/media/lottery-balls.1efa2165.png";